import { MediaClazz } from 'idt-ecommerce-api/catalog/products/medias/medias.models';

import { EcommerceBrandSettings } from './config.models';


export const EcommerceBrandSettingsStradivarius: EcommerceBrandSettings = {

  // --- Constants ---
  brandId: '5',
  brandName: 'Stradivarius',
  mediaPathSuffix: '1_1_2',

  // --- Functions ---

  // Ref: https://axinic.central.inditex.grp/confluence/display/ECOMNEG/Stradivarius+-+Proyecto+XMEDIA
  parseMediaClazzOverride(apiClazz: number) {
    let mediaClazz: MediaClazz;

    switch (apiClazz) {
      case 1:
        mediaClazz = { id: apiClazz, type: 'main' };
        break;
      case 2: case 21: case 22: case 23: case 24: case 25: case 26: case 27: case 28: case 29:
        mediaClazz = { id: apiClazz, type: 'secondary' };
        break;
      case 3:
        mediaClazz = { id: apiClazz, type: 'colorcut' };
        break;
      case 4: case 5:
        mediaClazz = { id: apiClazz, type: 'silhouette' };
        break;
      case 6: case 7:
        mediaClazz = { id: apiClazz, type: 'alternative' };
        break;
      case 8: case 9:
        mediaClazz = { id: apiClazz, type: 'double' };
        break;
      case 10:
        mediaClazz = { id: apiClazz, type: 'quadruple' };
        break;
      default:
        mediaClazz = { id: apiClazz, type: 'unknown' };
        break;
    }
    return mediaClazz;
  }
};
